// extracted by mini-css-extract-plugin
module.exports = {"themeProvider":"_2Z7Yxx-mHq_calculator","tokens":"_3SZhv28-3W_calculator"};